<template>
  <div class="out-content">
    <div class="marginBottom20">当前类别:
      <span class="marginLeft10 type-text"> {{ currentType || '未知负载'}} </span>
    </div>
    <div class="marginBottom20">正确类别:
      <span class="marginLeft10"> 
        <el-select v-model="correctType" placeholder="请选择正确类型">
        <el-option v-for="item in selectList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      </span>
    </div>
    <div style="text-align: center; margin-top: 10px;">
      <el-button @click="handleDialogClose">取消</el-button>
      <el-button type="primary" @click="submitCorrect(correctType)" :loading="showLoading">确定</el-button>
    </div>
  </div>
</template>

<script>
import { loadCorrect } from "@/api/waveform/load";
export default {
  name: "loadCorrect",
  props: {
    currentType: {
      type: [Number, String],
      default: "",
    },
    id: {
      type: [Number, String],
      default: "",
    },
    selectList: {
      type: Array,
      default: () => [], 
    }
  },
  data() {
    return {
      correctType: "",
      showLoading: false,
    }
  },
  methods: {
    handleDialogClose() {
      this.$emit("close");
    },
    submitCorrect(correctType) {
      this.showLoading = true;
      loadCorrect({"correctType":correctType, "id": this.id}).then((res) => {
        if (res.code === 200) {
          this.$message({
            message: "提交成功",
            type: "success",
          }); 
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          }); 
        }
      });
      this.showLoading = false;
      this.$emit("close");
    }
  }

}
</script>

<style scope>
.type-text {
  font-size: 16px;
  font-weight: bold;
}
.out-content{
  width: 100%;
  padding: 20px;
}
</style>